module.exports = __webpack_public_path__ + "static/media/bgcourse-2.5374dac3.jpg";